import { X } from "lucide-react";
import { useFilters } from "../../contexts/FilterContext";

export const ActiveFilters = () => {
  const { activeFilters, removeFilter, clearAllFilters } = useFilters();

  if (activeFilters.length === 0) {
    return null;
  }

  return (
    <div className="mt-4 space-y-2">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-gray-700">
          Active Filters:
        </span>
        <button
          onClick={clearAllFilters}
          className="text-sm text-gray-500 hover:text-gray-700"
        >
          Clear All
        </button>
      </div>

      <div className="flex flex-wrap gap-2">
        {activeFilters.map((filter) => (
          <div
            key={filter.type}
            className="flex items-center gap-1 px-3 py-1 bg-igbanwo-mint/10 border border-igbanwo-mint/20 rounded-full text-sm"
          >
            <span>{filter.label}</span>
            <button
              onClick={() => removeFilter(filter.type)}
              className="p-0.5 hover:bg-igbanwo-mint/20 rounded-full"
              aria-label={`Remove ${filter.type} filter`}
            >
              <X className="h-3 w-3" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};